import { $axios } from "@/utils/http.js";
import prefix from "../base.js";

export default {
  track(data) {
    return $axios(`${prefix.log}/report`, data, "POST");
  },
};
